import React, { useState } from "react";
import "./ServiceProduts.css";

const gemstoneData = [


   {category: "Gemstone",
    image: '/assets/products/Product_1.png',
    name: '7 Chakra Black Beads Mala (Protection + Healing)',
    offerPrice: 1800,
    sellPrice: 1200
  },

  {
    category: "Panna",
    image: '/assets/products/Product_2.png',
    name: 'Natural Emerald (Panna) – Certified Quality',
    offerPrice: 6000,
    sellPrice: 4500
  },
  {
    category: "Rudraksha",
     image: '/assets/products/Product_3.png',
    name: 'Red Sandalwood Mala (Chandan Mala)',
    // If crystal use: 'Brown Tourmaline Mala – Energy Protection'
    offerPrice: 2000,
    sellPrice: 1500,
  },
];

const ServiceProduts = () => {
  const [showForm, setShowForm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState("");

  const openPopup = (productName) => {
    setSelectedProduct(productName);
    setShowForm(true);
  };

  return (
    <div className="gemstone-page">
      <h2>Buy Gemstones</h2>

      <div className="gemstone-grid">
        {gemstoneData.map((item, index) => (
          <div className="gemstone-card" key={index}>
            <h4>{item.category}</h4>

            <img src={item.image} alt={item.name} />

            <h5>{item.name}</h5>

            {/* Price Section */}
            <p className="price-box">
              <span className="offer-price">₹{item.offerPrice}</span>
              <span className="sell-price">₹{item.sellPrice}</span>
            </p>

            <button onClick={() => openPopup(item.name)}>Buy Now</button>
          </div>
        ))}
      </div>

      {/* Popup Modal */}
      {showForm && (
        <div
          className="contact-form-overlay"
          onClick={() => setShowForm(false)}
        >
          <div
            className="contact-form-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>Contact Us</h2>

            <form>
              <input type="text" placeholder="Your Name" required />
              <input type="email" placeholder="Your Email" required />

              <textarea
                placeholder={`Your Message About: ${selectedProduct}`}
                rows="4"
                required
              ></textarea>

              <button type="submit">Send</button>
            </form>

            <button className="close-btn" onClick={() => setShowForm(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceProduts;
